module.exports = __webpack_public_path__ + "img/free-pricing.edd83de7.svg";